fragment StoryPreviewFragment on story_Entry {
  title
  slug
  uri
  readTime
  previewImage {
    url
    title
  }
  storiesCategories {
    uri
    title
  }
}
